import type { Article } from "@/types/content";

export const newsArticles: Article[] = [
  {
    id: "n01",
    section: "news",
    category: "轿车",
    title: "全新一代帕萨特正式上市：行政级舒适再进化",
    summary: "全新一代帕萨特完成换代，轴距进一步加长，后排舒适性与智能座舱全面升级，主打行政级家用市场。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20modern%20dark%20blue%20executive%20sedan%20parked%20in%20a%20bright%20minimalist%20showroom%2C%20soft%20natural%20daylight%2C%20clean%20neutral%20grey%20background%2C%20glossy%20paint%20reflections%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20smooth%20shadows%2C%20harmonious%20tones&width=800&height=600&seq=news-jc-01&orientation=landscape",
    author: "编辑部 · 陈默",
    date: "2026-10-12",
    readTime: 5,
    views: 48210,
    tags: ["轿车", "上市", "帕萨特", "德系"],
    brand: "大众",
    level: "中型车",
    content: [
      "全新一代帕萨特正式推向市场，作为品牌在行政级轿车市场的核心产品，新车在外观、空间与智能化三个维度完成系统升级。整车基于更新的平台架构打造，车身尺寸与轴距进一步增长，为后排乘客带来更宽裕的腿部空间。",
      "外观方面，新车采用更加扁平化的前脸设计，横向贯穿式进气格栅与锐利的矩阵式大灯连为一体，配合低风阻车身线条，在保留稳重气质的同时增加了年轻化元素。内饰则换上更大尺寸的悬浮中控屏，车机系统在响应速度与生态应用上均有提升。",
      "动力层面，全新帕萨特提供燃油与插电混动两套动力总成，其中插混版本在纯电续航与综合油耗上取得明显进步。业内人士认为，随着合资品牌持续强化舒适与智能配置，行政级家轿市场的竞争将更加激烈。",
    ],
  },
  {
    id: "n02",
    section: "news",
    category: "轿车",
    title: "2026款雅阁中期改款亮相，混动系统效率提升",
    summary: "2026款雅阁迎来中期改款，外观细节调整之外，第四代混动系统热效率提升，油耗表现成为最大亮点。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20sleek%20silver%20hybrid%20sedan%20driving%20on%20a%20smooth%20coastal%20highway%20at%20golden%20hour%2C%20soft%20warm%20sunlight%2C%20clean%20open%20sky%20background%2C%20motion%20blur%20wheels%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20harmonious%20tones&width=800&height=600&seq=news-jc-02&orientation=landscape",
    author: "编辑部 · 林一",
    date: "2026-10-11",
    readTime: 6,
    views: 39680,
    tags: ["轿车", "改款", "雅阁", "混动"],
    brand: "本田",
    level: "中型车",
    content: [
      "2026款雅阁完成中期改款，新车在外观上主要针对前保险杠、灯组内部结构以及轮毂造型进行了优化，整体观感更加精致。车漆新增两款配色，进一步丰富消费者的选择空间。",
      "动力是本次改款的重点。第四代双电机混动系统在发动机热效率、电控效率以及能量回收策略上均有升级，官方公布的综合油耗较老款进一步下降。城市工况下，车辆更多依赖电机驱动，行驶质感更加平顺安静。",
      "配置层面，新款雅阁将更大尺寸的中控屏和更完善的高级驾驶辅助列为标配或下探到更多车型，性价比优势得到强化。面对同价位新能源轿车的冲击，混动雅阁仍以可靠性与保值率作为主要卖点。",
    ],
  },
  {
    id: "n03",
    section: "news",
    category: "轿车",
    title: "丰田凯美瑞发布全新一代，全面混动化战略落地",
    summary: "全新一代凯美瑞取消纯燃油动力，全系以混动为主，标志丰田在中型轿车领域的电动化转型加速。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20white%20midsize%20hybrid%20sedan%20on%20a%20city%20street%20with%20modern%20glass%20buildings%2C%20soft%20daylight%2C%20clean%20neutral%20urban%20background%2C%20crisp%20reflections%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20balanced%20tones&width=800&height=600&seq=news-jc-03&orientation=landscape",
    author: "编辑部 · 周珂",
    date: "2026-10-10",
    readTime: 5,
    views: 35120,
    tags: ["轿车", "凯美瑞", "混动", "丰田"],
    brand: "丰田",
    level: "中型车",
    content: [
      "丰田正式发布全新一代凯美瑞，最受关注的变化在于动力总成：新车不再提供传统纯燃油版本，转而以新一代混动系统作为主力，全面混动化战略由此落地。",
      "全新一代车型基于更新的架构打造，车身刚性提升，悬挂调校在舒适与支撑之间取得新的平衡。内饰采用更简洁的横向布局，物理按键与触控屏结合，兼顾盲操作便利性与科技感。",
      "官方表示，新混动系统在电机功率和电池管理上均有改善，综合油耗与加速响应表现更佳。随着合资中型轿车加速向混动过渡，消费者在燃油经济性与驾驶体验之间的取舍空间正在扩大。",
    ],
  },
  {
    id: "n04",
    section: "news",
    category: "轿车",
    title: "宝马3系纯电版路试谍照曝光，续航有望突破700km",
    summary: "海外媒体拍摄到宝马3系纯电版本的路试谍照，新车将基于全新纯电平台，续航与快充能力备受关注。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20camouflaged%20electric%20sport%20sedan%20driving%20on%20a%20test%20track%2C%20soft%20overcast%20daylight%2C%20clean%20neutral%20background%20with%20subtle%20motion%2C%20low%20angle%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20cool%20tones&width=800&height=600&seq=news-jc-04&orientation=landscape",
    author: "编辑部 · 何宇",
    date: "2026-10-09",
    readTime: 4,
    views: 28940,
    tags: ["轿车", "宝马", "纯电", "谍照"],
    brand: "宝马",
    level: "中型车",
    content: [
      "一组宝马3系纯电版本的路试谍照近日流出。从伪装车轮廓看，新车保留了3系标志性的运动比例，但前脸封闭面积更大，预示其纯电身份。",
      "据外媒信息，新车将基于全新纯电专属平台打造，电池容量与能量密度均有提升，长续航版本的综合续航有望突破700公里，并支持更高功率的直流快充。",
      "内饰方面，新车预计搭载新一代座舱系统，人机交互与智能驾驶辅助能力进一步增强。作为豪华品牌中型轿车的标杆之一，3系纯电版的推出将对细分市场格局产生直接影响。",
    ],
  },
  {
    id: "n05",
    section: "news",
    category: "轿车",
    title: "比亚迪汉L正式开启预售，新一代电池技术加持",
    summary: "比亚迪汉L开启预售，搭载新一代刀片电池与高效电驱系统，主打长续航与高安全性。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20deep%20red%20electric%20flagship%20sedan%20in%20a%20dark%20studio%20with%20dramatic%20rim%20lighting%2C%20subtle%20reflections%20on%20glossy%20floor%2C%20clean%20neutral%20background%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20rich%20tones&width=800&height=600&seq=news-jc-05&orientation=landscape",
    author: "编辑部 · 苏晴",
    date: "2026-10-08",
    readTime: 5,
    views: 51260,
    tags: ["轿车", "比亚迪", "预售", "纯电"],
    brand: "比亚迪",
    level: "中大型车",
    content: [
      "比亚迪汉L正式开启预售，作为品牌在中大型轿车市场的旗舰产品，新车在电池、电驱与智能化方面均有明显升级。预售价格区间覆盖主流新能源中大型轿车市场。",
      "新车搭载新一代刀片电池，在能量密度、安全性与循环寿命方面进一步优化，配合高功率电驱系统，四驱版本零百加速进入更高性能区间，长续航版本续航表现突出。",
      "智能化方面，汉L主打高阶智能座舱与辅助驾驶，车机生态与语音交互的流畅度是重点宣传方向。业内认为，汉L的上市将进一步加剧中大型新能源轿车的竞争。",
    ],
  },
  {
    id: "n06",
    section: "news",
    category: "轿车",
    title: "别克君越迎来换代，主打静谧性与后排舒适",
    summary: "别克君越完成换代，以出色的 NVH 控制和后排舒适配置，重新定义行政级家轿的乘坐体验。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20black%20luxury%20sedan%20parked%20in%20front%20of%20a%20modern%20hotel%20entrance%20at%20dusk%2C%20soft%20warm%20ambient%20light%2C%20clean%20neutral%20architectural%20background%2C%20elegant%20reflections%2C%20high%20detail%2C%20professional%20magazine%20composition&width=800&height=600&seq=news-jc-06&orientation=landscape",
    author: "编辑部 · 郑楠",
    date: "2026-10-07",
    readTime: 5,
    views: 24310,
    tags: ["轿车", "别克", "换代", "舒适"],
    brand: "别克",
    level: "中大型车",
    content: [
      "别克君越迎来全新换代。新车延续品牌在乘坐舒适性上的传统优势，将 NVH 静音表现与后排舒适配置作为核心竞争力。",
      "整车通过双层隔音玻璃、主动降噪与优化后的底盘衬套，营造出更安静的座舱环境。后排座椅支持更大幅度的角度调节，并新增通风与按摩功能，面向商务与家庭双场景。",
      "动力方面，新车提供燃油与轻混版本，动力输出以平顺为主。面对新能源轿车的冲击，君越选择以质感与舒适性作为差异化卖点，瞄准注重乘坐体验的用户群体。",
    ],
  },
  {
    id: "n07",
    section: "news",
    category: "SUV",
    title: "全新途观L Pro上市，智能座舱全面升级",
    summary: "全新途观L Pro正式上市，重点升级智能座舱与驾驶辅助，继续巩固合资紧凑 SUV 市场地位。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20modern%20blue%20compact%20suv%20parked%20on%20a%20scenic%20mountain%20road%20overlook%2C%20soft%20natural%20daylight%2C%20clean%20open%20landscape%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20balanced%20tones&width=800&height=600&seq=news-suv-01&orientation=landscape",
    author: "编辑部 · 陈默",
    date: "2026-10-12",
    readTime: 5,
    views: 43120,
    tags: ["SUV", "上市", "途观", "智能座舱"],
    brand: "大众",
    level: "紧凑型SUV",
    content: [
      "全新途观L Pro正式上市。作为合资紧凑型 SUV 的代表车型，新车将升级重点放在智能座舱与高级驾驶辅助上，以应对自主品牌的强势竞争。",
      "车内采用大尺寸双联屏布局，车机系统换用响应更快的芯片，并支持更丰富的本土化应用。语音助手增加了连续对话能力，交互体验明显改善。",
      "空间依旧是途观L Pro的强项，加长轴距带来宽裕的后排与后备箱容积。动力沿用成熟的涡轮增压发动机与双离合变速箱组合，兼顾动力响应与燃油经济性。",
    ],
  },
  {
    id: "n08",
    section: "news",
    category: "SUV",
    title: "理想L6月销再破高点，家庭 SUV 格局生变",
    summary: "理想L6交付量持续攀升，增程路线在家庭 SUV 市场的接受度进一步提高。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20light%20silver%20family%20suv%20parked%20in%20a%20sunlit%20suburban%20driveway%2C%20soft%20daylight%2C%20clean%20neutral%20residential%20background%2C%20warm%20welcoming%20tones%2C%20high%20detail%2C%20professional%20magazine%20composition&width=800&height=600&seq=news-suv-02&orientation=landscape",
    author: "编辑部 · 林一",
    date: "2026-10-11",
    readTime: 4,
    views: 47890,
    tags: ["SUV", "理想", "销量", "增程"],
    brand: "理想",
    level: "中大型SUV",
    content: [
      "理想L6交付数据再次刷新纪录，月销量稳居同价位区间前列。作为品牌面向年轻家庭的入门车型，L6凭借增程路线解决了补能焦虑，成为家庭用户的热门选择。",
      "产品定义上，L6延续了理想一贯的“移动的家”思路：大空间、舒适座椅与丰富的娱乐配置，配合成熟的城市与高速辅助驾驶，满足多成员家庭的出行需求。",
      "业内分析认为，L6的强势表现正在改变家庭 SUV 的竞争格局，促使更多品牌加码增程与空间化路线。价格与配置的快速内卷，也让消费者获得了更高的性价比。",
    ],
  },
  {
    id: "n09",
    section: "news",
    category: "SUV",
    title: "丰田汉兰达新增插混版本，油耗大幅下降",
    summary: "汉兰达新增插电混动版本，纯电通勤与长途低油耗兼顾，进一步丰富大七座 SUV 的选择。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20dark%20grey%20seven%20seat%20suv%20on%20a%20highway%20with%20green%20countryside%2C%20soft%20daylight%2C%20clean%20neutral%20landscape%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20natural%20tones&width=800&height=600&seq=news-suv-03&orientation=landscape",
    author: "编辑部 · 周珂",
    date: "2026-10-10",
    readTime: 5,
    views: 31280,
    tags: ["SUV", "汉兰达", "插混", "丰田"],
    brand: "丰田",
    level: "中大型SUV",
    content: [
      "丰田为汉兰达新增插电混动版本，进一步丰富大七座 SUV 的产品矩阵。新车在保留可靠性与空间优势的同时，显著降低了日常使用油耗。",
      "插混版本支持一定里程的纯电行驶，用户在城市通勤时可实现接近纯电的体验，长途出行则依靠混动系统降低油耗焦虑。电池布局经过优化，未明显侵占车内空间。",
      "对于注重稳定与保值率的家庭用户而言，插混汉兰达提供了燃油与纯电之间的折中方案。随着合资品牌加速插混布局，大七座市场的竞争将进一步升温。",
    ],
  },
  {
    id: "n10",
    section: "news",
    category: "SUV",
    title: "比亚迪唐DM-i改款发布，主打大五座布局",
    summary: "唐DM-i改款车型发布，新增五座版本，突出空间灵活性与低油耗表现。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20deep%20blue%20hybrid%20suv%20parked%20at%20a%20modern%20outdoor%20charging%20station%2C%20soft%20daylight%2C%20clean%20neutral%20concrete%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20cool%20tones&width=800&height=600&seq=news-suv-04&orientation=landscape",
    author: "编辑部 · 苏晴",
    date: "2026-10-09",
    readTime: 4,
    views: 36540,
    tags: ["SUV", "比亚迪", "改款", "插混"],
    brand: "比亚迪",
    level: "中大型SUV",
    content: [
      "比亚迪唐DM-i迎来改款，此次新增主打大五座布局的版本，针对不需要七座的用户提供更宽敞的后排与后备箱空间。",
      "新车沿用成熟的双模混动系统，以电驱为主、发动机为辅，城市工况油耗表现出色。电池版本提供多种纯电续航选择，满足不同通勤距离的用户。",
      "配置方面，改款唐DM-i升级了座舱屏幕与智能驾驶辅助，并优化了底盘舒适性。作为自主品牌中大型 SUV 的代表，唐DM-i持续以性价比与能耗优势参与竞争。",
    ],
  },
  {
    id: "n11",
    section: "news",
    category: "SUV",
    title: "大众探岳L官图发布，轴距加长提升空间",
    summary: "探岳L官图正式发布，加长轴距带来更宽裕的后排空间，瞄准家庭用户需求。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20white%20midsize%20suv%20on%20a%20clean%20desert%20road%20at%20sunrise%2C%20soft%20warm%20light%2C%20clean%20minimal%20landscape%20background%2C%20crisp%20shadows%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20warm%20tones&width=800&height=600&seq=news-suv-05&orientation=landscape",
    author: "编辑部 · 何宇",
    date: "2026-10-08",
    readTime: 4,
    views: 26730,
    tags: ["SUV", "探岳", "官图", "大众"],
    brand: "大众",
    level: "中型SUV",
    content: [
      "大众发布探岳L官方图片，新车主打“L”即加长概念，轴距较标准版明显增长，后排腿部空间得到实质提升，面向注重空间的家庭用户。",
      "外观延续大众家族式设计语言，前脸更显宽大，贯穿式灯组与发光车标强化了辨识度。车身侧面线条简洁有力，整体比例更加舒展。",
      "动力预计提供多种涡轮增压与插混选择，满足不同用户需求。随着合资 SUV 普遍加长，空间尺寸已成为该细分市场竞争的关键指标之一。",
    ],
  },
  {
    id: "n12",
    section: "news",
    category: "SUV",
    title: "长城哈弗猛龙上市，硬派越野风格吸睛",
    summary: "哈弗猛龙正式上市，方盒子造型与插混四驱系统结合，主打轻越野与个性出行。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20rugged%20boxy%20offroad%20suv%20on%20a%20gravel%20trail%20with%20distant%20mountains%2C%20soft%20overcast%20daylight%2C%20clean%20neutral%20natural%20background%2C%20bold%20stance%2C%20high%20detail%2C%20professional%20magazine%20composition&width=800&height=600&seq=news-suv-06&orientation=landscape",
    author: "编辑部 · 郑楠",
    date: "2026-10-07",
    readTime: 5,
    views: 33890,
    tags: ["SUV", "哈弗", "越野", "插混"],
    brand: "哈弗",
    level: "紧凑型SUV",
    content: [
      "哈弗猛龙正式上市，凭借方盒子造型与硬派气质吸引大量关注。新车定位轻越野 SUV，兼顾城市通勤与周末户外场景。",
      "动力采用插电混动四驱系统，前后双电机提供更好的脱困能力，同时保留较低的城市油耗。车辆配备多地形模式与一定的涉水能力，满足轻度越野需求。",
      "内饰强调实用与耐用，同时加入大尺寸中控屏与智能互联功能。随着个性化出行需求上升，硬派风格 SUV 正成为新的增长点。",
    ],
  },
  {
    id: "n13",
    section: "news",
    category: "新能源车",
    title: "小米SU7累计交付突破新高，产能持续爬坡",
    summary: "小米SU7交付量持续增长，产能瓶颈逐步缓解，智能生态成为核心卖点。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20sleek%20electric%20sport%20sedan%20in%20a%20bright%20minimalist%20showroom%2C%20soft%20daylight%2C%20clean%20neutral%20grey%20background%2C%20glossy%20reflections%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20modern%20tones&width=800&height=600&seq=news-nev-01&orientation=landscape",
    author: "编辑部 · 苏晴",
    date: "2026-10-12",
    readTime: 4,
    views: 62140,
    tags: ["新能源", "小米", "纯电", "交付"],
    brand: "小米",
    level: "中大型车",
    content: [
      "小米SU7累计交付量再创新高，随着工厂产能持续爬坡，交付周期较上市初期明显缩短。作为新势力中的跨界玩家，小米凭借生态优势迅速打开市场。",
      "产品层面，SU7主打高性能电机与流畅的智能座舱体验，与手机、家居设备的互联是其差异化卖点。高配版本在加速与续航上均有亮眼数据。",
      "业内认为，小米的入局加速了新能源轿车的竞争，也推动传统车企在智能化体验上加速追赶。产能与交付能力将是其后续增长的关键。",
    ],
  },
  {
    id: "n14",
    section: "news",
    category: "新能源车",
    title: "特斯拉Model Y焕新版上市，售价体系微调",
    summary: "Model Y焕新版上市，外观内饰细节优化，续航与舒适性小幅提升。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20white%20electric%20crossover%20suv%20in%20a%20clean%20modern%20charging%20plaza%20at%20dusk%2C%20soft%20ambient%20light%2C%20clean%20neutral%20architectural%20background%2C%20subtle%20reflections%2C%20high%20detail%2C%20professional%20magazine%20composition&width=800&height=600&seq=news-nev-02&orientation=landscape",
    author: "编辑部 · 何宇",
    date: "2026-10-11",
    readTime: 4,
    views: 55320,
    tags: ["新能源", "特斯拉", "纯电", "上市"],
    brand: "特斯拉",
    level: "中型SUV",
    content: [
      "特斯拉Model Y焕新版正式上市，新车在外观细节与内饰用料上进行了优化，并对售价体系作出微调，以应对日益激烈的市场竞争。",
      "焕新版重点改善了座舱静谧性与悬挂舒适度，同时续航里程小幅提升。中控系统延续极简风格，功能主要集中在大屏操作，OTA 升级能力依旧是其优势。",
      "作为全球畅销的纯电车型之一，Model Y 的每一次更新都会引发市场关注。面对自主品牌的强势冲击，特斯拉在性价比与本土化体验上仍在持续调整。",
    ],
  },
  {
    id: "n15",
    section: "news",
    category: "新能源车",
    title: "蔚来发布第三代换电站，单次换电再提速",
    summary: "蔚来第三代换电站上线，换电效率与兼容性提升，补能网络进一步加密。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20futuristic%20battery%20swap%20station%20with%20an%20electric%20suv%2C%20soft%20evening%20light%2C%20clean%20neutral%20modern%20background%2C%20subtle%20glow%20accents%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20cool%20tones&width=800&height=600&seq=news-nev-03&orientation=landscape",
    author: "编辑部 · 周珂",
    date: "2026-10-10",
    readTime: 5,
    views: 41870,
    tags: ["新能源", "蔚来", "换电", "补能"],
    brand: "蔚来",
    level: "中大型SUV",
    content: [
      "蔚来正式发布第三代换电站，新一代站点在换电速度、电池兼容性与运营效率上均有提升，进一步巩固其换电补能体系的差异化优势。",
      "新站支持更多电池规格并行存储，单次换电时间进一步缩短，用户在高峰时段的等待压力得到缓解。同时，站点建设成本与占地面积有所优化，便于网络快速铺开。",
      "蔚来表示将继续扩大换电网络覆盖，并向更多高速沿线与三四线城市延伸。补能体验仍是纯电用户的核心痛点，换电模式的规模化将持续受到行业关注。",
    ],
  },
  {
    id: "n16",
    section: "news",
    category: "新能源车",
    title: "小鹏MONA M03热销，智能驾驶下探到主流价位",
    summary: "小鹏 MONA M03 销量走高，将高阶智能驾驶带入更亲民的价格区间。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20compact%20electric%20sedan%20in%20a%20vibrant%20city%20street%20with%20modern%20architecture%2C%20soft%20daylight%2C%20clean%20neutral%20urban%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20fresh%20tones&width=800&height=600&seq=news-nev-04&orientation=landscape",
    author: "编辑部 · 林一",
    date: "2026-10-09",
    readTime: 4,
    views: 38910,
    tags: ["新能源", "小鹏", "智能驾驶", "纯电"],
    brand: "小鹏",
    level: "紧凑型车",
    content: [
      "小鹏 MONA M03 上市后销量持续走高，成为品牌在主流价位市场的重要走量车型。该车最大的看点在于将高阶智能驾驶能力下探到更亲民的价格区间。",
      "依托小鹏在视觉感知与算法上的积累，M03 在高速与城市辅助驾驶场景中表现稳定，功能覆盖度在同价位车型中具有竞争力。",
      "此外，M03 在能耗控制与设计上也获得不少好评。业内认为，智能驾驶正从高端配置向主流车型普及，这将深刻改变消费者的购车决策逻辑。",
    ],
  },
  {
    id: "n17",
    section: "news",
    category: "新能源车",
    title: "宁德时代发布增混专用电池，纯电续航再突破",
    summary: "宁德时代推出面向增程与插混车型的专用电池，纯电续航与充电倍率显著提升。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20high%20tech%20battery%20module%20displayed%20in%20a%20clean%20research%20lab%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20background%2C%20precise%20detail%2C%20professional%20magazine%20composition%2C%20cool%20tones&width=800&height=600&seq=news-nev-05&orientation=landscape",
    author: "编辑部 · 陈默",
    date: "2026-10-08",
    readTime: 4,
    views: 29760,
    tags: ["新能源", "电池", "宁德时代", "技术"],
    brand: "宁德时代",
    level: "产业链",
    content: [
      "宁德时代发布面向增程与插混车型的专用电池产品。相比传统方案，新电池在纯电续航里程与充电倍率上均有明显提升，旨在改善增混车型“纯电续航偏短”的痛点。",
      "该电池在低温性能与循环寿命方面也进行了针对性优化，以适应增混车型频繁浅充浅放的使用特征。厂商表示将有多家车企在后续车型中采用。",
      "随着增程与插混车型销量增长，专用电池的推出有望进一步提升这类产品的竞争力，并推动电池技术在细分场景下走向精细化。",
    ],
  },
  {
    id: "n18",
    section: "news",
    category: "新能源车",
    title: "极氪007改款上市，全系标配高压平台",
    summary: "极氪007改款上市，全系标配高压架构与更快的充电能力，补齐智能座舱体验。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20grey%20electric%20sport%20sedan%20parked%20in%20a%20dark%20minimalist%20garage%20with%20light%20strips%2C%20soft%20dramatic%20lighting%2C%20clean%20neutral%20background%2C%20glossy%20reflections%2C%20high%20detail%2C%20professional%20magazine%20composition&width=800&height=600&seq=news-nev-06&orientation=landscape",
    author: "编辑部 · 郑楠",
    date: "2026-10-07",
    readTime: 4,
    views: 32450,
    tags: ["新能源", "极氪", "改款", "快充"],
    brand: "极氪",
    level: "中大型车",
    content: [
      "极氪007改款车型正式上市，本次改款将高压电气架构列为全系标配，配合更高效的快充能力，进一步强化补能体验。",
      "新车在外观上保留了辨识度较高的设计语言，同时对内饰材质与座舱系统进行了优化，车机流畅度与生态应用更加完善。",
      "动力方面，改款车型提供后驱与四驱版本，四驱性能版的加速表现依旧亮眼。随着高压快充逐步普及，补能效率正成为纯电车型竞争的又一焦点。",
    ],
  },
  {
    id: "n19",
    section: "news",
    category: "性能跑车",
    title: "保时捷911新款发布，混动版本首次登场",
    summary: "保时捷新款911发布，首次引入混动系统，在性能与效率之间寻找新平衡。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20silver%20rear%20engine%20sports%20car%20on%20a%20mountain%20pass%20at%20sunset%2C%20soft%20warm%20light%2C%20clean%20open%20landscape%20background%2C%20sharp%20detail%2C%20professional%20magazine%20composition%2C%20rich%20tones&width=800&height=600&seq=news-perf-01&orientation=landscape",
    author: "编辑部 · 何宇",
    date: "2026-10-12",
    readTime: 5,
    views: 44980,
    tags: ["性能车", "保时捷", "混动", "跑车"],
    brand: "保时捷",
    level: "跑车",
    content: [
      "保时捷发布新款911，最受关注的是首次引入的混动系统。这套系统并未牺牲性能，反而通过电机辅助进一步提升了加速响应与赛道表现。",
      "新车在空气动力学与底盘调校上继续进化，主动悬挂与后轮转向的协同让车辆在高速与弯道中更加稳定。外观变化克制，依然保留了911经典的家族轮廓。",
      "作为跑车领域的标杆，911的电动化路径一直备受瞩目。混动版本的推出，被业界视为传统性能跑车在电动化时代的重要探索。",
    ],
  },
  {
    id: "n20",
    section: "news",
    category: "性能跑车",
    title: "法拉利全新旗舰跑车亮相，零百加速再破纪录",
    summary: "法拉利全新旗舰跑车正式亮相，插混动力系统带来惊人的加速表现。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20red%20hybrid%20supercar%20in%20a%20dark%20studio%20with%20dramatic%20lighting%2C%20subtle%20rim%20highlights%2C%20clean%20neutral%20background%2C%20glossy%20floor%20reflections%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20bold%20tones&width=800&height=600&seq=news-perf-02&orientation=landscape",
    author: "编辑部 · 陈默",
    date: "2026-10-11",
    readTime: 4,
    views: 40120,
    tags: ["性能车", "法拉利", "超跑", "混动"],
    brand: "法拉利",
    level: "超跑",
    content: [
      "法拉利全新旗舰跑车正式亮相，新车搭载插电混动动力系统，综合输出功率创下品牌量产车新高，零百加速时间再次刷新纪录。",
      "外观设计围绕空气动力学展开，主动式尾翼与复杂的车身导流结构在高速下提供强大下压力。内饰以驾驶者为中心，大量采用轻量化材料。",
      "尽管电动化引发诸多讨论，但法拉利通过混动系统证明了性能与电气化并不矛盾。新旗舰的推出，进一步明确了其在高性能领域的技术路线。",
    ],
  },
  {
    id: "n21",
    section: "news",
    category: "性能跑车",
    title: "全新福特Mustang国内上市，大排量V8得以保留",
    summary: "全新Mustang国内上市，5.0升V8版本仍在列，成为燃油性能车爱好者的关注焦点。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20blue%20american%20muscle%20car%20on%20an%20open%20desert%20highway%2C%20soft%20late%20afternoon%20light%2C%20clean%20neutral%20landscape%20background%2C%20bold%20stance%2C%20high%20detail%2C%20professional%20magazine%20composition&width=800&height=600&seq=news-perf-03&orientation=landscape",
    author: "编辑部 · 周珂",
    date: "2026-10-10",
    readTime: 4,
    views: 27640,
    tags: ["性能车", "福特", "V8", "上市"],
    brand: "福特",
    level: "跑车",
    content: [
      "全新福特Mustang在国内正式上市，在电动化浪潮下，5.0升V8自然吸气版本得以保留，成为燃油性能车爱好者的关注焦点。",
      "新车在保留肌肉车造型语言的基础上，加入了更多现代设计元素，内饰的数字化程度明显提升，提供多种驾驶模式与赛道功能。",
      "虽然在排放与法规压力下大排量发动机日益稀少，但Mustang依旧坚持提供V8选项。对于追求声浪与情怀的用户而言，这份坚持具有独特意义。",
    ],
  },
  {
    id: "n22",
    section: "news",
    category: "性能跑车",
    title: "兰博基尼Huracán继任者曝光，全面插电混动化",
    summary: "兰博基尼入门超跑继任者谍照曝光，将采用插混动力，告别纯内燃机时代。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20camouflaged%20angular%20supercar%20on%20a%20race%20track%20with%20motion%20blur%2C%20soft%20overcast%20light%2C%20clean%20neutral%20background%2C%20dynamic%20stance%2C%20high%20detail%2C%20professional%20magazine%20composition%2C%20cool%20tones&width=800&height=600&seq=news-perf-04&orientation=landscape",
    author: "编辑部 · 林一",
    date: "2026-10-09",
    readTime: 4,
    views: 25310,
    tags: ["性能车", "兰博基尼", "插混", "谍照"],
    brand: "兰博基尼",
    level: "超跑",
    content: [
      "兰博基尼入门级超跑的继任车型谍照近日曝光。从伪装车造型看，新车延续了品牌标志性的棱角设计，整车姿态更低趴、更具攻击性。",
      "据外媒信息，新车将采用插电混动动力系统，内燃机与电机的组合在保证性能的同时降低排放。这也意味着品牌将全面进入电气化时代。",
      "对于超跑品牌而言，电动化既是法规压力也是技术机遇。混合动力能否延续内燃机时代的声浪与激情，将成为车迷持续讨论的话题。",
    ],
  },
  {
    id: "n23",
    section: "news",
    category: "新能源车",
    title: "充电基础设施建设提速，全国充电桩规模持续扩大",
    summary: "全国充电基础设施加快建设，公共快充与超充比例提升，补能便利性持续改善。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20row%20of%20modern%20electric%20vehicle%20charging%20stations%20under%20a%20clean%20sky%2C%20soft%20daylight%2C%20clean%20neutral%20urban%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20bright%20tones&width=800&height=600&seq=news-nev-07&orientation=landscape",
    author: "编辑部 · 郑楠",
    date: "2026-10-06",
    readTime: 4,
    views: 22180,
    tags: ["新能源", "充电", "基础设施", "政策"],
    brand: "行业",
    level: "产业链",
    content: [
      "随着新能源汽车保有量快速增长，全国充电基础设施建设同步提速。公共充电桩总量持续扩大，其中直流快充与大功率超充的比例稳步提升。",
      "高速公路服务区、城市商圈与居民社区的补能网络不断完善，节假日出行高峰的排队压力有所缓解。多个城市还在推动小区充电设施的统一规划与改造。",
      "业内人士指出，补能便利性直接影响用户的购车决策。随着充电网络进一步加密，新能源汽车的使用门槛将持续降低，有助于渗透率继续提升。",
    ],
  },
  {
    id: "n24",
    section: "news",
    category: "轿车",
    title: "紧凑型轿车市场竞争加剧，合资品牌加速换代",
    summary: "面对自主品牌冲击，多款合资紧凑型轿车加速换代，智能化与性价比成为突围重点。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20automotive%20photography%20of%20a%20compact%20sedan%20parked%20on%20a%20clean%20city%20street%20with%20trees%2C%20soft%20morning%20light%2C%20clean%20neutral%20urban%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20fresh%20tones&width=800&height=600&seq=news-jc-07&orientation=landscape",
    author: "编辑部 · 苏晴",
    date: "2026-10-05",
    readTime: 4,
    views: 19920,
    tags: ["轿车", "市场", "紧凑型", "换代"],
    brand: "行业",
    level: "紧凑型车",
    content: [
      "紧凑型轿车市场正经历新一轮竞争。自主品牌凭借新能源与高配置快速上量，促使合资品牌加快换代节奏，在智能化与性价比上寻求突破。",
      "近期多款合资紧凑轿车的改款均集中在两个方面：一是提升车机与辅助驾驶配置，二是通过终端优惠或价格调整增强竞争力。",
      "分析认为，紧凑型轿车是销量基盘最大的细分市场，谁能在智能化体验与购买成本之间找到平衡，谁就更有可能在激烈竞争中站稳脚跟。",
    ],
  },
];